//let itemArray = JSON.parse(localStorage.getItem("addObject")) || []
$(document).ready(function () {

  var bodyHeight = $(window).height();
  var headerHeight = $(".header").height();

  $("body").on("click", "#logoutBtn", function (e) {
    var lang = localStorage.getItem('lang');
    localStorage.clear();
    localStorage.setItem('lang', lang);
  });

  $(window).scroll(function (e) {
    if ($(this).scrollTop() >= 71) {
      $("body, section.content").addClass("headerScrolled");
      $("body #iframe").parent().addClass("makeFieldSticky");
      $("body #iframe").addClass("animate");
    } else {
      $("body").removeClass("headerScrolled");
      $("body #iframe").parent().removeClass("makeFieldSticky");
      $("body #iframe").removeClass("animate");
    }
  });

  if ($("body").hasClass("bg-black")) {
    $("body").removeClass("bg-black");
  }

  $("body").on("click", ".betSlipHeader", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (e.target.getAttribute('id') != "userSelect") {
      if ($(e.currentTarget).parent().hasClass("slideDown")) {
        $(e.currentTarget).parent().removeClass("slideDown");
        $("body").removeClass("betSlipOpened");
      } else {
        $(e.currentTarget).parent().addClass("slideDown");
        $("body").addClass("betSlipOpened");
      }
    }

  });


  if ($(window).width() < 1300) {
    $("body .leftPanel").css({
      "min-height": "auto",
    });
    $("body .rightPanel").css({
      height: "auto",
    });
  } else if ($(window).width() < 600) {
    $(window).scroll(function (e) {
      if ($(this).scrollTop() >= 140) {
        $(".rightPanel").css({
          height: bodyHeight - 61 + "px",
        });
      } else {
        $(".rightPanel").css({
          height: bodyHeight - 106 + "px",
        });
      }
    });
  } else {
    $("body .leftPanel").css({
      "min-height": bodyHeight - 105,
    });
    // $("body .rightPanel").css({
    //   height: bodyHeight - headerHeight - 1 + "px",
    // });

    $(".betBtn").on("click", function () {
      $(".loginBtn").click();
    });

    $(window).scroll(function (e) {
      if ($(this).scrollTop() >= 71) {
        $(".rightPanel").css({
          height: bodyHeight - 61 + "px",
        });
      } else {
        $(".rightPanel").css({
          height: bodyHeight - 106 + "px",
        });
      }
    });
  }

  $("body").on("click", ".betSlipHeader", function (e) {
    if ($(e.currentTarget).parent().hasClass("slideDown")) {
      $(e.currentTarget).parent().removeClass("slideDown");
      $("body").removeClass("betSlipOpened");
      $(e.currentTarget)
          .parent()
          .css({
            height: 50 + "px",
          });
    } else {
      $(e.currentTarget).parent().addClass("slideDown");
      $("body").addClass("betSlipOpened");
      $(e.currentTarget)
          .parent()
          .css({
            height: bodyHeight - 150 + "px",
          });
    }
  });

  $(window).resize(function () {
    var bodyHeight = $(window).height();
    var headerHeight = $(".header").height();
    if ($(window).width() < 1300) {
      $("body .leftPanel").css({
        "min-height": "auto",
      });
      $("body .rightPanel").css({
        height: "auto",
      });

      $(window).scroll(function (e) {
        if ($(this).scrollTop() >= 140) {
          $(".rightPanel").css({ height: "auto" });
        } else {
          $(".rightPanel").css({ height: "auto" });
        }
      });

      // $('body .betSlip').css({
      //     'height': 50 + 'px'
      // });

      $("body").on("click", ".betSlipHeader", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if ($(e.currentTarget).parent().hasClass("slideDown")) {
          $(e.currentTarget)
            .parent()
            .css({
              height: 50 + "px",
            });
        } else {
          $(e.currentTarget)
            .parent()
            .css({
              height: bodyHeight - 150 + "px",
            });
        }
      });
    } else {
      $("body .betSlip").addClass("slideDown");
      $("body .betSlip").css({
        height: "inherit",
      });

      $("body .leftPanel").css({
        "min-height": bodyHeight - 105,
      });
      $("body .rightPanel").css({
        // height: bodyHeight - headerHeight - 1 + "px",
        height: "auto",
        maxHeight: bodyHeight - headerHeight - 1 + "px",
      });

      $(".betBtn").on("click", function () {
        $(".loginBtn").click();
      });

      $(window).scroll(function (e) {
        if ($(this).scrollTop() >= 140) {
          $(".rightPanel").css({ height: bodyHeight - 61 + "px" });
        } else {
          $(".rightPanel").css({ height: bodyHeight - 106 + "px" });
        }
      });

      if ($(window).width() < 600) {
        $("body .betSlip").css({
          height: "100%",
        });
        $("body").removeClass("betSlipOpened");
        $("body .betSlip").removeClass("slideDown");
      }
    }
  });

  $(document).mouseup(function (e) {
    var container = $("body .leftPanel");
    var secondContainer = $("body .betSlip");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      if ($("body").hasClass("menuOpened")) {
        $("body").removeClass("menuOpened");
      }
    }
  });

  $("body").on("click", ".burgerBtn", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if ($("body").hasClass("menuOpened")) {
      $("body").removeClass("menuOpened");
    } else {
      $("body").addClass("menuOpened");
    }
  });
  $('body .mainSlider').slick({
    dots: false,
    infinite: true,
    speed: 2000,
    centerMode: true,
    dots: false,
    prevArrow: false,
    nextArrow: false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    centerPadding: '20px',
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1,
          centerPadding: '20px',
        }
      }
    ]
  });
  

  $("body").on("click", ".closeModal", function () {
    $(".betSlip").addClass("hideMe");
    $(".betSlip").removeClass("slideDown");
    $("body").removeClass("betSlipOpened");
    const itemArrayA = JSON.parse(localStorage.getItem("addObject")) || [];
    itemArray = [];
    localStorage.setItem("addObject", JSON.stringify(itemArray));
    localStorage.removeItem('coefHasChanged');
    console.log(localStorage);
    $("body .betSlipSingleItem").remove();
    $("body .bettingBtn").removeClass("betSlipAdded");
    $("body .betCount span").text(0);

    if (itemArrayA) {
        itemArrayA.forEach((item) => {
          const event = new CustomEvent("leaveRoom", {
            detail: item.gameId,
          });
          window.dispatchEvent(event);
        });
    }

  });

  // $("body").on("click", ".mainLeftMenuItem a", function () {
  //   $("body").removeClass("menuOpened");
  // });

  $("body").on("click", ".headerHide", function () {
    $("body").addClass("headerScrolledStatic");
  });

  $(window).scroll(function (e) {
    if ($(this).scrollTop() == 0) {
      $("body").removeClass("headerScrolledStatic");
    }
  });

  let scrollVar = 0;
  $('body .scrollHelper').children('.slotsItem').each(function (i, item) {
    scrollVar += $(item).outerWidth();
  });

  $('body .scrollHelper').css({
    'width': 200 + 'px'
  })


  let scrollVar2 = 0;
  $('body .scrollHelper1').children('.slotsItem').each(function (i, item) {
    scrollVar2 += $(item).outerWidth();
  });

  $('body .scrollHelper1').css({
    'width': scrollVar2 + 'px'
  })


  let scrollVar3 = 0;
  $('body .scrollHelper2').children('.slotsItem').each(function (i, item) {
    scrollVar3 += $(item).outerWidth();
  });

  $('body .scrollHelper2').css({
    'width': scrollVar3 + 'px'
  })

  let scrollVar4 = 0;
  $('body .scrollHelper3').children('.slotsItem').each(function (i, item) {
    scrollVar4 += $(item).outerWidth();
  });

  $('body .scrollHelper3').css({
    'width': scrollVar4 + 'px'
  })

  $('body').on('click', '.rouletteBtn', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (!localStorage.getItem("access_token") || localStorage.getItem("access_token") == '') {
      alert('Login!');
      return;
    }

    const gameName = 'LuxRoulette';
    console.log(
      `${location.origin}/casino/index?game=${gameName}&u=${localStorage.getItem(
        "access_token"
      )}`
    );
    var win = window.open(
      `${location.origin}/casino/index?game=${gameName}&u=${localStorage.getItem(
        "access_token"
      )}`,
      "_blank"
    );
    if (win) {
      //Browser has allowed it to be opened
      win.focus();
    } else {
      //Browser has blocked it
      alert("Please allow popups for this website");
    }
  });





});
